// This list needs to be approved by PHE before modifications
const ethnicities = [
  'ANY OTHER ETHNIC CATEGORY',
  'ANY OTHER MIXED GROUP',
  'BANGLADESHI',
  'BLACK - AFRICAN',
  'BLACK - CARIBBEAN',
  'BLACK - OTHER',
  'CHINESE',
  'INDIAN',
  'OTHER / MIXED',
  'PAKISTANI',
  'UNKNOWN',
  'WHITE',
  'WHITE AND ASIAN',
  'WHITE AND BLACK AFRICAN',
  'WHITE AND BLACK CARIBBEAN',
  'WHITE BRITISH',
  'WHITE IRISH',
  'WHITE OTHER',
]

export default ethnicities
